export const style = {
  menu: {
    margin: `0 -20px`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/partials/Editor/style/menu.js